<template>
  <svg
    v-if="isDirectionDefault"
    width="13"
    height="17"
    viewBox="0 0 13 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.5 0.876953L11.6962 7.90659H1.30385L6.5 0.876953Z"
      fill="#D4D9DC"
    />
    <path
      d="M6.5 16.623L1.30385 9.59341L11.6962 9.59341L6.5 16.623Z"
      fill="#D4D9DC"
    />
  </svg>
  <svg
    v-else-if="isDirectionAsc"
    width="13"
    height="17"
    viewBox="0 0 13 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.5 0.876953L11.6962 7.90659H1.30385L6.5 0.876953Z"
      fill="#171717"
    />
    <path
      d="M6.5 16.623L1.30385 9.59341L11.6962 9.59341L6.5 16.623Z"
      fill="#D4D9DC"
    />
  </svg>
  <svg
    v-else
    width="13"
    height="17"
    viewBox="0 0 13 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.5 0.876953L11.6962 7.90659H1.30385L6.5 0.876953Z"
      fill="#D4D9DC"
    />
    <path
      d="M6.5 16.623L1.30385 9.59341L11.6962 9.59341L6.5 16.623Z"
      fill="#171717"
    />
  </svg>
</template>
<script>
export default {
  props: {
    sortDirection: {
      type: String,
      default: () => 'default',
      required: true
    }
  },
  computed: {
    isDirectionDefault () {
      return this.sortDirection === 'default'
    },
    isDirectionAsc () {
      return this.sortDirection === 'asc'
    }
  }
}
</script>
